// extracted by mini-css-extract-plugin
export default {"superUsersPage":"SuperUsersPage_superUsersPage__4DlCa"};